export default __webpack_public_path__ + "static/media/search.14e14704.svg";